// extracted by mini-css-extract-plugin
module.exports = {"button":"_37J6z","typePill":"_7JhbN","fixedWidth":"wDnab","typePrimary":"_1FdMH","large":"_3ypzk"};